import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  display: flex;

  path {
    fill: ${({ theme }) => {
      return theme.colors.backgroundForm;
    }};
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    margin: 0 0 0 3px;
    border: none;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    background-color: ${({ theme }) => {
      return theme.colors.blue;
    }};
    cursor: pointer;
    transition: filter 200ms ease-in-out;
    &:hover {
      filter: brightness(80%);
    }
  }

  button:last-of-type {
    background-color: ${({ theme, buttonCheck }) => {
      if (buttonCheck) {
        return theme.colors.alert;
      }
    }};
  }
`;
